import type { CursorPage, SettlementRecord } from "./types";

/** Collect a complete selection before applying it; failed pages never select a partial result. */
export async function collectPendingSettlements(
  load: (cursor?: string) => Promise<CursorPage<SettlementRecord>>,
  signal?: AbortSignal,
): Promise<SettlementRecord[]> {
  const records = new Map<string, SettlementRecord>();
  const cursors = new Set<string>();
  let cursor: string | undefined;
  do {
    signal?.throwIfAborted();
    const page = await load(cursor);
    signal?.throwIfAborted();
    for (const record of page.items) if (record.status === "pending" && !record.batchId) records.set(record.id, record);
    cursor = page.nextCursor ?? undefined;
    if (cursor && cursors.has(cursor)) throw new Error("미정산 목록을 끝까지 확인하지 못했습니다. 전체 선택을 다시 시도해 주세요.");
    if (cursor) cursors.add(cursor);
  } while (cursor);
  return [...records.values()];
}
